import {
  className,
  getCookie,
  getRentalDates, 
  preparePriceRequest,
  getSelectedAddons,
  getSelectedFees,
  addAddon,
  addFee
} from '@shared/functions'
window.addEventListener( 'DOMContentLoaded', () => {
  const datePickerBlock = document.querySelector(`.${className}`)
  const messageBox = document.querySelector(`.wp-block-webdevia-rental-dates__message-box`)
  const addToCardBlock = document.querySelector('.wp-block-webdevia-rental-add-to-card')
  if (addToCardBlock ) {
    var qty = addToCardBlock.querySelector('.wp-block-webdevia-rental-add-to-card__quantity input')
    var rentForm = addToCardBlock.querySelector('form')
    var options = JSON.parse( addToCardBlock.dataset?.options )
  }

  let gSelectedDates

  // Try localStorage first (works even when cookies are blocked), then fall back to cookie
  const storedDates = getRentalDates()
  if ( storedDates ) {
    gSelectedDates = storedDates
    addToCardBlock.querySelector('input[name="dates"]').value = JSON.stringify(storedDates)
  }

  if( rentForm ) {
    rentForm.addEventListener( 'submit', e => {
      // Re-read dates on submit: localStorage first, then cookie, then the hidden input field
      const latestDates = getRentalDates()
      if ( latestDates ) {
        gSelectedDates = latestDates
        addToCardBlock.querySelector('input[name="dates"]').value = JSON.stringify(latestDates)
      } else {
        // Last resort: read from the hidden input that rental-dates/view.js may have already set
        const datesInputVal = addToCardBlock.querySelector('input[name="dates"]').value
        if ( datesInputVal ) {
          try { gSelectedDates = JSON.parse(datesInputVal) } catch(err) { /* ignore parse errors */ }
        }
      }

      const err = durationAndPrice.querySelector('.callout__error')
      if( !gSelectedDates || gSelectedDates.length == 0 || messageBox.innerHTML != '' || err ) {
        e.preventDefault()
        messageBox.innerHTML += `<br/>Please clear errors before submitting!`
        messageBox.style.display = 'block'
      } else {
        messageBox.innerHTML = ``
        messageBox.style.display = 'none'
      }
    } )
  }
  // @if type = 'pro'
  //----------- Addons
  if( !!datePickerBlock ) {
    const addons = datePickerBlock.querySelector('.list-addons')
    if ( addons ) {
      const addonsInput = addToCardBlock.querySelector('input[name=wd_addons]')
      let addonsRequest = false
      addons.querySelectorAll('.list-addons__addon input').forEach( addon => {
        if( addon.checked ) {
          addAddon( addon.value )
          addonsRequest = true
        }
      })
      if(addonsRequest) {
        addonsInput.value = JSON.stringify(getSelectedAddons())
      }
    }
  }

  //----------- Additional fees
  if( !!datePickerBlock ) {
    const fees = datePickerBlock.querySelector('.list-fees')
    if ( fees ) {
      const feesInput = addToCardBlock.querySelector('input[name=wd_fees]')
      let feesRequest = false
      fees.querySelectorAll('.list-fees__fee input').forEach( fee => {
        if( fee.checked ) {
          addFee( fee.value )
          feesRequest = true
        }
      })
      if(feesRequest) {
        feesInput.value = JSON.stringify(getSelectedFees())
      }
    }
  }
  // @endif
  if( qty ) {
    qty.addEventListener( 'change', e => {
      preparePriceRequest(options, e.target.value)
    })
  }
} )